import { i as F, x as m, a as lt, c as nt } from "../lit-element-8JrrHldg.js";
import { S as ut } from "../shoelace-event-controller-BFWPTmUE.js";
import { c as H } from "../chunk.TUVJKY7S-CZwfrQkU.js";
import { S as z, a as s } from "../chunk.UYAO2JRR-CUGf3xdB.js";
import { f as ht, d as et, F as j, l as dt, v as ct } from "../live-BdoGs16l.js";
import { L as G } from "../chunk.WLV3FVBR-BO0XtQ7O.js";
import { H as rt } from "../chunk.NYIIDP5N-r_KwQazp.js";
import { S as K } from "../chunk.E6QAPUBK-CYG-_UAc.js";
import { w as M } from "../chunk.CCJUT23E-JJ_URTr3.js";
import { e as V } from "../class-map-Di-Oe7s4.js";
import { o as b } from "../if-defined-Cd-e8xtV.js";
import { n as l } from "../property-4FoNj0Pi.js";
import { r as k } from "../state-D4BCZ2JK.js";
import { e as C } from "../query-C42EGI_8.js";
import { d as T } from "../chunk.ESELY2US-BpLloTbu.js";
import { S as pt } from "../chunk.ZSH6VD4N-C_iD5Mw7.js";
import { c as _ } from "../chunk.HF7GESMZ-DqTA6ya4.js";
import { S as bt } from "../chunk.TLKDQ5JG-ClJ6bjhy.js";
import { i as W, u as L } from "../static-CPcCYSrK.js";
import { t as gt } from "../event-options-CYHYGOd8.js";
import { o as x } from "../style-map-F8T0o2lr.js";
import "../chunk.5J7BMMD5-Duf78PT9.js";
var ft = F`
  :host(:not(:focus-within)) {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    clip: rect(0 0 0 0) !important;
    clip-path: inset(50%) !important;
    border: none !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    padding: 0 !important;
  }
`, ot = class extends z {
  render() {
    return m` <slot></slot> `;
  }
};
ot.styles = [H, ft];
var mt = F`
  :host {
    display: block;
  }

  .input {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: stretch;
    justify-content: start;
    position: relative;
    width: 100%;
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-input-font-weight);
    letter-spacing: var(--sl-input-letter-spacing);
    vertical-align: middle;
    overflow: hidden;
    cursor: text;
    transition:
      var(--sl-transition-fast) color,
      var(--sl-transition-fast) border,
      var(--sl-transition-fast) box-shadow,
      var(--sl-transition-fast) background-color;
  }

  /* Standard inputs */
  .input--standard {
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
  }

  .input--standard:hover:not(.input--disabled) {
    background-color: var(--sl-input-background-color-hover);
    border-color: var(--sl-input-border-color-hover);
  }

  .input--standard.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-background-color-focus);
    border-color: var(--sl-input-border-color-focus);
    box-shadow: 0 0 0 var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
  }

  .input--standard.input--focused:not(.input--disabled) .input__control {
    color: var(--sl-input-color-focus);
  }

  .input--standard.input--disabled {
    background-color: var(--sl-input-background-color-disabled);
    border-color: var(--sl-input-border-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input--standard.input--disabled .input__control {
    color: var(--sl-input-color-disabled);
  }

  .input--standard.input--disabled .input__control::placeholder {
    color: var(--sl-input-placeholder-color-disabled);
  }

  /* Filled inputs */
  .input--filled {
    border: none;
    background-color: var(--sl-input-filled-background-color);
    color: var(--sl-input-color);
  }

  .input--filled:hover:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-hover);
  }

  .input--filled.input--focused:not(.input--disabled) {
    background-color: var(--sl-input-filled-background-color-focus);
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .input--filled.input--disabled {
    background-color: var(--sl-input-filled-background-color-disabled);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .input__control {
    flex: 1 1 auto;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    min-width: 0;
    height: 100%;
    color: var(--sl-input-color);
    border: none;
    background: inherit;
    box-shadow: none;
    padding: 0;
    margin: 0;
    cursor: inherit;
    -webkit-appearance: none;
  }

  .input__control::-webkit-search-decoration,
  .input__control::-webkit-search-cancel-button,
  .input__control::-webkit-search-results-button,
  .input__control::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }

  .input__control:-webkit-autofill,
  .input__control:-webkit-autofill:hover,
  .input__control:-webkit-autofill:focus,
  .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-background-color-hover) inset !important;
    -webkit-text-fill-color: var(--sl-color-primary-500);
    caret-color: var(--sl-input-color);
  }

  .input--filled .input__control:-webkit-autofill,
  .input--filled .input__control:-webkit-autofill:hover,
  .input--filled .input__control:-webkit-autofill:focus,
  .input--filled .input__control:-webkit-autofill:active {
    box-shadow: 0 0 0 var(--sl-input-height-large) var(--sl-input-filled-background-color) inset !important;
  }

  .input__control::placeholder {
    color: var(--sl-input-placeholder-color);
    user-select: none;
    -webkit-user-select: none;
  }

  .input:hover:not(.input--disabled) .input__control {
    color: var(--sl-input-color-hover);
  }

  .input__control:focus {
    outline: none;
  }

  .input__prefix,
  .input__suffix {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    cursor: default;
  }

  .input__prefix ::slotted(sl-icon),
  .input__suffix ::slotted(sl-icon) {
    color: var(--sl-input-icon-color);
  }

  /*
   * Size modifiers
   */

  .input--small {
    border-radius: var(--sl-input-border-radius-small);
    font-size: var(--sl-input-font-size-small);
    height: var(--sl-input-height-small);
  }

  .input--small .input__control {
    height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-small);
  }

  .input--small .input__clear,
  .input--small .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-small) * 2);
  }

  .input--small .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-small);
  }

  .input--small .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-small);
  }

  .input--medium {
    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    height: var(--sl-input-height-medium);
  }

  .input--medium .input__control {
    height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-medium);
  }

  .input--medium .input__clear,
  .input--medium .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-medium) * 2);
  }

  .input--medium .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-medium);
  }

  .input--medium .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-medium);
  }

  .input--large {
    border-radius: var(--sl-input-border-radius-large);
    font-size: var(--sl-input-font-size-large);
    height: var(--sl-input-height-large);
  }

  .input--large .input__control {
    height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    padding: 0 var(--sl-input-spacing-large);
  }

  .input--large .input__clear,
  .input--large .input__password-toggle {
    width: calc(1em + var(--sl-input-spacing-large) * 2);
  }

  .input--large .input__prefix ::slotted(*) {
    margin-inline-start: var(--sl-input-spacing-large);
  }

  .input--large .input__suffix ::slotted(*) {
    margin-inline-end: var(--sl-input-spacing-large);
  }

  /*
   * Pill modifier
   */

  .input--pill.input--small {
    border-radius: var(--sl-input-height-small);
  }

  .input--pill.input--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .input--pill.input--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Clearable + Password Toggle
   */

  .input__clear,
  .input__password-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--sl-input-icon-color);
    border: none;
    background: none;
    padding: 0;
    transition: var(--sl-transition-fast) color;
    cursor: pointer;
  }

  .input__clear:hover,
  .input__password-toggle:hover {
    color: var(--sl-input-icon-color-hover);
  }

  .input__clear:focus,
  .input__password-toggle:focus {
    outline: none;
  }

  /* Don't show the browser's password toggle in Edge */
  ::-ms-reveal {
    display: none;
  }

  /* Hide the built-in number spinner */
  .input--no-spin-buttons input[type='number']::-webkit-outer-spin-button,
  .input--no-spin-buttons input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
  }

  .input--no-spin-buttons input[type='number'] {
    -moz-appearance: textfield;
  }
`, u = class extends z {
  constructor() {
    super(...arguments), this.formControlController = new j(this, {
      assumeInteractionOn: ["sl-blur", "sl-input"]
    }), this.hasSlotController = new rt(this, "help-text", "label"), this.localize = new G(this), this.hasFocus = !1, this.title = "", this.__numberInput = Object.assign(document.createElement("input"), { type: "number" }), this.__dateInput = Object.assign(document.createElement("input"), { type: "date" }), this.type = "text", this.name = "", this.value = "", this.defaultValue = "", this.size = "medium", this.filled = !1, this.pill = !1, this.label = "", this.helpText = "", this.clearable = !1, this.disabled = !1, this.placeholder = "", this.readonly = !1, this.passwordToggle = !1, this.passwordVisible = !1, this.noSpinButtons = !1, this.form = "", this.required = !1, this.spellcheck = !0;
  }
  //
  // NOTE: We use an in-memory input for these getters/setters instead of the one in the template because the properties
  // can be set before the component is rendered.
  //
  /**
   * Gets or sets the current value as a `Date` object. Returns `null` if the value can't be converted. This will use the native `<input type="{{type}}">` implementation and may result in an error.
   */
  get valueAsDate() {
    var t;
    return this.__dateInput.type = this.type, this.__dateInput.value = this.value, ((t = this.input) == null ? void 0 : t.valueAsDate) || this.__dateInput.valueAsDate;
  }
  set valueAsDate(t) {
    this.__dateInput.type = this.type, this.__dateInput.valueAsDate = t, this.value = this.__dateInput.value;
  }
  /** Gets or sets the current value as a number. Returns `NaN` if the value can't be converted. */
  get valueAsNumber() {
    var t;
    return this.__numberInput.value = this.value, ((t = this.input) == null ? void 0 : t.valueAsNumber) || this.__numberInput.valueAsNumber;
  }
  set valueAsNumber(t) {
    this.__numberInput.valueAsNumber = t, this.value = this.__numberInput.value;
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleChange() {
    this.value = this.input.value, this.emit("sl-change");
  }
  handleClearClick(t) {
    t.preventDefault(), this.value !== "" && (this.value = "", this.emit("sl-clear"), this.emit("sl-input"), this.emit("sl-change")), this.input.focus();
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleInput() {
    this.value = this.input.value, this.formControlController.updateValidity(), this.emit("sl-input");
  }
  handleInvalid(t) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(t);
  }
  handleKeyDown(t) {
    const e = t.metaKey || t.ctrlKey || t.shiftKey || t.altKey;
    t.key === "Enter" && !e && setTimeout(() => {
      !t.defaultPrevented && !t.isComposing && this.formControlController.submit();
    });
  }
  handlePasswordToggle() {
    this.passwordVisible = !this.passwordVisible;
  }
  handleDisabledChange() {
    this.formControlController.setValidity(this.disabled);
  }
  handleStepChange() {
    this.input.step = String(this.step), this.formControlController.updateValidity();
  }
  async handleValueChange() {
    await this.updateComplete, this.formControlController.updateValidity();
  }
  /** Sets focus on the input. */
  focus(t) {
    this.input.focus(t);
  }
  /** Removes focus from the input. */
  blur() {
    this.input.blur();
  }
  /** Selects all the text in the input. */
  select() {
    this.input.select();
  }
  /** Sets the start and end positions of the text selection (0-based). */
  setSelectionRange(t, e, r = "none") {
    this.input.setSelectionRange(t, e, r);
  }
  /** Replaces a range of text with a new string. */
  setRangeText(t, e, r, o = "preserve") {
    const i = e ?? this.input.selectionStart, a = r ?? this.input.selectionEnd;
    this.input.setRangeText(t, i, a, o), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Displays the browser picker for an input element (only works if the browser supports it for the input type). */
  showPicker() {
    "showPicker" in HTMLInputElement.prototype && this.input.showPicker();
  }
  /** Increments the value of a numeric input type by the value of the step attribute. */
  stepUp() {
    this.input.stepUp(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Decrements the value of a numeric input type by the value of the step attribute. */
  stepDown() {
    this.input.stepDown(), this.value !== this.input.value && (this.value = this.input.value);
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(t) {
    this.input.setCustomValidity(t), this.formControlController.updateValidity();
  }
  render() {
    const t = this.hasSlotController.test("label"), e = this.hasSlotController.test("help-text"), r = this.label ? !0 : !!t, o = this.helpText ? !0 : !!e, a = this.clearable && !this.disabled && !this.readonly && (typeof this.value == "number" || this.value.length > 0);
    return m`
      <div
        part="form-control"
        class=${V({
      "form-control": !0,
      "form-control--small": this.size === "small",
      "form-control--medium": this.size === "medium",
      "form-control--large": this.size === "large",
      "form-control--has-label": r,
      "form-control--has-help-text": o
    })}
      >
        <label
          part="form-control-label"
          class="form-control__label"
          for="input"
          aria-hidden=${r ? "false" : "true"}
        >
          <slot name="label">${this.label}</slot>
        </label>

        <div part="form-control-input" class="form-control-input">
          <div
            part="base"
            class=${V({
      input: !0,
      // Sizes
      "input--small": this.size === "small",
      "input--medium": this.size === "medium",
      "input--large": this.size === "large",
      // States
      "input--pill": this.pill,
      "input--standard": !this.filled,
      "input--filled": this.filled,
      "input--disabled": this.disabled,
      "input--focused": this.hasFocus,
      "input--empty": !this.value,
      "input--no-spin-buttons": this.noSpinButtons
    })}
          >
            <span part="prefix" class="input__prefix">
              <slot name="prefix"></slot>
            </span>

            <input
              part="input"
              id="input"
              class="input__control"
              type=${this.type === "password" && this.passwordVisible ? "text" : this.type}
              title=${this.title}
              name=${b(this.name)}
              ?disabled=${this.disabled}
              ?readonly=${this.readonly}
              ?required=${this.required}
              placeholder=${b(this.placeholder)}
              minlength=${b(this.minlength)}
              maxlength=${b(this.maxlength)}
              min=${b(this.min)}
              max=${b(this.max)}
              step=${b(this.step)}
              .value=${dt(this.value)}
              autocapitalize=${b(this.autocapitalize)}
              autocomplete=${b(this.autocomplete)}
              autocorrect=${b(this.autocorrect)}
              ?autofocus=${this.autofocus}
              spellcheck=${this.spellcheck}
              pattern=${b(this.pattern)}
              enterkeyhint=${b(this.enterkeyhint)}
              inputmode=${b(this.inputmode)}
              aria-describedby="help-text"
              @change=${this.handleChange}
              @input=${this.handleInput}
              @invalid=${this.handleInvalid}
              @keydown=${this.handleKeyDown}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
            />

            ${a ? m`
                  <button
                    part="clear-button"
                    class="input__clear"
                    type="button"
                    aria-label=${this.localize.term("clearEntry")}
                    @click=${this.handleClearClick}
                    tabindex="-1"
                  >
                    <slot name="clear-icon">
                      <sl-icon name="x-circle-fill" library="system"></sl-icon>
                    </slot>
                  </button>
                ` : ""}
            ${this.passwordToggle && !this.disabled ? m`
                  <button
                    part="password-toggle-button"
                    class="input__password-toggle"
                    type="button"
                    aria-label=${this.localize.term(this.passwordVisible ? "hidePassword" : "showPassword")}
                    @click=${this.handlePasswordToggle}
                    tabindex="-1"
                  >
                    ${this.passwordVisible ? m`
                          <slot name="show-password-icon">
                            <sl-icon name="eye-slash" library="system"></sl-icon>
                          </slot>
                        ` : m`
                          <slot name="hide-password-icon">
                            <sl-icon name="eye" library="system"></sl-icon>
                          </slot>
                        `}
                  </button>
                ` : ""}

            <span part="suffix" class="input__suffix">
              <slot name="suffix"></slot>
            </span>
          </div>
        </div>

        <div
          part="form-control-help-text"
          id="help-text"
          class="form-control__help-text"
          aria-hidden=${o ? "false" : "true"}
        >
          <slot name="help-text">${this.helpText}</slot>
        </div>
      </div>
    `;
  }
};
u.styles = [H, ht, mt];
u.dependencies = { "sl-icon": K };
s([
  C(".input__control")
], u.prototype, "input", 2);
s([
  k()
], u.prototype, "hasFocus", 2);
s([
  l()
], u.prototype, "title", 2);
s([
  l({ reflect: !0 })
], u.prototype, "type", 2);
s([
  l()
], u.prototype, "name", 2);
s([
  l()
], u.prototype, "value", 2);
s([
  et()
], u.prototype, "defaultValue", 2);
s([
  l({ reflect: !0 })
], u.prototype, "size", 2);
s([
  l({ type: Boolean, reflect: !0 })
], u.prototype, "filled", 2);
s([
  l({ type: Boolean, reflect: !0 })
], u.prototype, "pill", 2);
s([
  l()
], u.prototype, "label", 2);
s([
  l({ attribute: "help-text" })
], u.prototype, "helpText", 2);
s([
  l({ type: Boolean })
], u.prototype, "clearable", 2);
s([
  l({ type: Boolean, reflect: !0 })
], u.prototype, "disabled", 2);
s([
  l()
], u.prototype, "placeholder", 2);
s([
  l({ type: Boolean, reflect: !0 })
], u.prototype, "readonly", 2);
s([
  l({ attribute: "password-toggle", type: Boolean })
], u.prototype, "passwordToggle", 2);
s([
  l({ attribute: "password-visible", type: Boolean })
], u.prototype, "passwordVisible", 2);
s([
  l({ attribute: "no-spin-buttons", type: Boolean })
], u.prototype, "noSpinButtons", 2);
s([
  l({ reflect: !0 })
], u.prototype, "form", 2);
s([
  l({ type: Boolean, reflect: !0 })
], u.prototype, "required", 2);
s([
  l()
], u.prototype, "pattern", 2);
s([
  l({ type: Number })
], u.prototype, "minlength", 2);
s([
  l({ type: Number })
], u.prototype, "maxlength", 2);
s([
  l()
], u.prototype, "min", 2);
s([
  l()
], u.prototype, "max", 2);
s([
  l()
], u.prototype, "step", 2);
s([
  l()
], u.prototype, "autocapitalize", 2);
s([
  l()
], u.prototype, "autocorrect", 2);
s([
  l()
], u.prototype, "autocomplete", 2);
s([
  l({ type: Boolean })
], u.prototype, "autofocus", 2);
s([
  l()
], u.prototype, "enterkeyhint", 2);
s([
  l({
    type: Boolean,
    converter: {
      // Allow "true|false" attribute values but keep the property boolean
      fromAttribute: (t) => !(!t || t === "false"),
      toAttribute: (t) => t ? "true" : "false"
    }
  })
], u.prototype, "spellcheck", 2);
s([
  l()
], u.prototype, "inputmode", 2);
s([
  M("disabled", { waitUntilFirstUpdate: !0 })
], u.prototype, "handleDisabledChange", 1);
s([
  M("step", { waitUntilFirstUpdate: !0 })
], u.prototype, "handleStepChange", 1);
s([
  M("value", { waitUntilFirstUpdate: !0 })
], u.prototype, "handleValueChange", 1);
var vt = F`
  :host {
    --grid-width: 280px;
    --grid-height: 200px;
    --grid-handle-size: 16px;
    --slider-height: 15px;
    --slider-handle-size: 17px;
    --swatch-size: 25px;

    display: inline-block;
  }

  .color-picker {
    width: var(--grid-width);
    font-family: var(--sl-font-sans);
    font-size: var(--sl-font-size-medium);
    font-weight: var(--sl-font-weight-normal);
    color: var(--color);
    background-color: var(--sl-panel-background-color);
    border-radius: var(--sl-border-radius-medium);
    user-select: none;
    -webkit-user-select: none;
  }

  .color-picker--inline {
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
  }

  .color-picker--inline:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-picker__grid {
    position: relative;
    height: var(--grid-height);
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%),
      linear-gradient(to right, #fff 0%, rgba(255, 255, 255, 0) 100%);
    border-top-left-radius: var(--sl-border-radius-medium);
    border-top-right-radius: var(--sl-border-radius-medium);
    cursor: crosshair;
    forced-color-adjust: none;
  }

  .color-picker__grid-handle {
    position: absolute;
    width: var(--grid-handle-size);
    height: var(--grid-handle-size);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    border: solid 2px white;
    margin-top: calc(var(--grid-handle-size) / -2);
    margin-left: calc(var(--grid-handle-size) / -2);
    transition: var(--sl-transition-fast) scale;
  }

  .color-picker__grid-handle--dragging {
    cursor: none;
    scale: 1.5;
  }

  .color-picker__grid-handle:focus-visible {
    outline: var(--sl-focus-ring);
  }

  .color-picker__controls {
    padding: var(--sl-spacing-small);
    display: flex;
    align-items: center;
  }

  .color-picker__sliders {
    flex: 1 1 auto;
  }

  .color-picker__slider {
    position: relative;
    height: var(--slider-height);
    border-radius: var(--sl-border-radius-pill);
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
    forced-color-adjust: none;
  }

  .color-picker__slider:not(:last-of-type) {
    margin-bottom: var(--sl-spacing-small);
  }

  .color-picker__slider-handle {
    position: absolute;
    top: calc(50% - var(--slider-handle-size) / 2);
    width: var(--slider-handle-size);
    height: var(--slider-handle-size);
    background-color: white;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    margin-left: calc(var(--slider-handle-size) / -2);
  }

  .color-picker__slider-handle:focus-visible {
    outline: var(--sl-focus-ring);
  }

  .color-picker__hue {
    background-image: linear-gradient(
      to right,
      rgb(255, 0, 0) 0%,
      rgb(255, 255, 0) 17%,
      rgb(0, 255, 0) 33%,
      rgb(0, 255, 255) 50%,
      rgb(0, 0, 255) 67%,
      rgb(255, 0, 255) 83%,
      rgb(255, 0, 0) 100%
    );
  }

  .color-picker__alpha .color-picker__alpha-gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
  }

  .color-picker__preview {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 2.25rem;
    height: 2.25rem;
    border: none;
    border-radius: var(--sl-border-radius-circle);
    background: none;
    margin-left: var(--sl-spacing-small);
    cursor: copy;
    forced-color-adjust: none;
  }

  .color-picker__preview:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);

    /* We use a custom property in lieu of currentColor because of https://bugs.webkit.org/show_bug.cgi?id=216780 */
    background-color: var(--preview-color);
  }

  .color-picker__preview:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-picker__preview-color {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: solid 1px rgba(0, 0, 0, 0.125);
  }

  .color-picker__preview-color--copied {
    animation: pulse 0.75s;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 var(--sl-color-primary-500);
    }
    70% {
      box-shadow: 0 0 0 0.5rem transparent;
    }
    100% {
      box-shadow: 0 0 0 0 transparent;
    }
  }

  .color-picker__user-input {
    display: flex;
    padding: 0 var(--sl-spacing-small) var(--sl-spacing-small) var(--sl-spacing-small);
  }

  .color-picker__user-input sl-input {
    min-width: 0; /* fix input width in Safari */
    flex: 1 1 auto;
  }

  .color-picker__user-input sl-button-group {
    margin-left: var(--sl-spacing-small);
  }

  .color-picker__user-input sl-button {
    min-width: 3.25rem;
    max-width: 3.25rem;
    font-size: 1rem;
  }

  .color-picker__swatches {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-gap: 0.5rem;
    justify-items: center;
    border-top: solid 1px var(--sl-color-neutral-200);
    padding: var(--sl-spacing-small);
    forced-color-adjust: none;
  }

  .color-picker__swatch {
    position: relative;
    width: var(--swatch-size);
    height: var(--swatch-size);
    border-radius: var(--sl-border-radius-small);
  }

  .color-picker__swatch .color-picker__swatch-color {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: solid 1px rgba(0, 0, 0, 0.125);
    border-radius: inherit;
    cursor: pointer;
  }

  .color-picker__swatch:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-picker__transparent-bg {
    background-image: linear-gradient(45deg, var(--sl-color-neutral-300) 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, var(--sl-color-neutral-300) 75%),
      linear-gradient(45deg, transparent 75%, var(--sl-color-neutral-300) 75%),
      linear-gradient(45deg, var(--sl-color-neutral-300) 25%, transparent 25%);
    background-size: 10px 10px;
    background-position:
      0 0,
      0 0,
      -5px -5px,
      5px 5px;
  }

  .color-picker--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .color-picker--disabled .color-picker__grid,
  .color-picker--disabled .color-picker__grid-handle,
  .color-picker--disabled .color-picker__slider,
  .color-picker--disabled .color-picker__slider-handle,
  .color-picker--disabled .color-picker__preview,
  .color-picker--disabled .color-picker__swatch,
  .color-picker--disabled .color-picker__swatch-color {
    pointer-events: none;
  }

  /*
   * Color dropdown
   */

  .color-dropdown::part(panel) {
    max-height: none;
    background-color: var(--sl-panel-background-color);
    border: solid var(--sl-panel-border-width) var(--sl-panel-border-color);
    border-radius: var(--sl-border-radius-medium);
    overflow: visible;
  }

  .color-dropdown__trigger {
    display: inline-block;
    position: relative;
    background-color: transparent;
    border: none;
    cursor: pointer;
    forced-color-adjust: none;
  }

  .color-dropdown__trigger.color-dropdown__trigger--small {
    width: var(--sl-input-height-small);
    height: var(--sl-input-height-small);
    border-radius: var(--sl-border-radius-circle);
  }

  .color-dropdown__trigger.color-dropdown__trigger--medium {
    width: var(--sl-input-height-medium);
    height: var(--sl-input-height-medium);
    border-radius: var(--sl-border-radius-circle);
  }

  .color-dropdown__trigger.color-dropdown__trigger--large {
    width: var(--sl-input-height-large);
    height: var(--sl-input-height-large);
    border-radius: var(--sl-border-radius-circle);
  }

  .color-dropdown__trigger:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background-color: currentColor;
    box-shadow:
      inset 0 0 0 2px var(--sl-input-border-color),
      inset 0 0 0 4px var(--sl-color-neutral-0);
  }

  .color-dropdown__trigger--empty:before {
    background-color: transparent;
  }

  .color-dropdown__trigger:focus-visible {
    outline: none;
  }

  .color-dropdown__trigger:focus-visible:not(.color-dropdown__trigger--disabled) {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .color-dropdown__trigger.color-dropdown__trigger--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`, yt = F`
  :host {
    display: inline-block;
    position: relative;
    width: auto;
    cursor: pointer;
  }

  .button {
    display: inline-flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    border-style: solid;
    border-width: var(--sl-input-border-width);
    font-family: var(--sl-input-font-family);
    font-weight: var(--sl-font-weight-semibold);
    text-decoration: none;
    user-select: none;
    -webkit-user-select: none;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0;
    transition:
      var(--sl-transition-x-fast) background-color,
      var(--sl-transition-x-fast) color,
      var(--sl-transition-x-fast) border,
      var(--sl-transition-x-fast) box-shadow;
    cursor: inherit;
  }

  .button::-moz-focus-inner {
    border: 0;
  }

  .button:focus {
    outline: none;
  }

  .button:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: var(--sl-focus-ring-offset);
  }

  .button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* When disabled, prevent mouse events from bubbling up from children */
  .button--disabled * {
    pointer-events: none;
  }

  .button__prefix,
  .button__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    pointer-events: none;
  }

  .button__label {
    display: inline-block;
  }

  .button__label::slotted(sl-icon) {
    vertical-align: -2px;
  }

  /*
   * Standard buttons
   */

  /* Default */
  .button--standard.button--default {
    background-color: var(--sl-color-neutral-0);
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--standard.button--default:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-50);
    border-color: var(--sl-color-primary-300);
    color: var(--sl-color-primary-700);
  }

  .button--standard.button--default:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-100);
    border-color: var(--sl-color-primary-400);
    color: var(--sl-color-primary-700);
  }

  /* Primary */
  .button--standard.button--primary {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:hover:not(.button--disabled) {
    background-color: var(--sl-color-primary-500);
    border-color: var(--sl-color-primary-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--primary:active:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--standard.button--success {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:hover:not(.button--disabled) {
    background-color: var(--sl-color-success-500);
    border-color: var(--sl-color-success-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--success:active:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--standard.button--neutral {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:hover:not(.button--disabled) {
    background-color: var(--sl-color-neutral-500);
    border-color: var(--sl-color-neutral-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--neutral:active:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--standard.button--warning {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }
  .button--standard.button--warning:hover:not(.button--disabled) {
    background-color: var(--sl-color-warning-500);
    border-color: var(--sl-color-warning-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--warning:active:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--standard.button--danger {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:hover:not(.button--disabled) {
    background-color: var(--sl-color-danger-500);
    border-color: var(--sl-color-danger-500);
    color: var(--sl-color-neutral-0);
  }

  .button--standard.button--danger:active:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  /*
   * Outline buttons
   */

  .button--outline {
    background: none;
    border: solid 1px;
  }

  /* Default */
  .button--outline.button--default {
    border-color: var(--sl-input-border-color);
    color: var(--sl-color-neutral-700);
  }

  .button--outline.button--default:hover:not(.button--disabled),
  .button--outline.button--default.button--checked:not(.button--disabled) {
    border-color: var(--sl-color-primary-600);
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--default:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Primary */
  .button--outline.button--primary {
    border-color: var(--sl-color-primary-600);
    color: var(--sl-color-primary-600);
  }

  .button--outline.button--primary:hover:not(.button--disabled),
  .button--outline.button--primary.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-primary-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--primary:active:not(.button--disabled) {
    border-color: var(--sl-color-primary-700);
    background-color: var(--sl-color-primary-700);
    color: var(--sl-color-neutral-0);
  }

  /* Success */
  .button--outline.button--success {
    border-color: var(--sl-color-success-600);
    color: var(--sl-color-success-600);
  }

  .button--outline.button--success:hover:not(.button--disabled),
  .button--outline.button--success.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-success-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--success:active:not(.button--disabled) {
    border-color: var(--sl-color-success-700);
    background-color: var(--sl-color-success-700);
    color: var(--sl-color-neutral-0);
  }

  /* Neutral */
  .button--outline.button--neutral {
    border-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-600);
  }

  .button--outline.button--neutral:hover:not(.button--disabled),
  .button--outline.button--neutral.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-neutral-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--neutral:active:not(.button--disabled) {
    border-color: var(--sl-color-neutral-700);
    background-color: var(--sl-color-neutral-700);
    color: var(--sl-color-neutral-0);
  }

  /* Warning */
  .button--outline.button--warning {
    border-color: var(--sl-color-warning-600);
    color: var(--sl-color-warning-600);
  }

  .button--outline.button--warning:hover:not(.button--disabled),
  .button--outline.button--warning.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-warning-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--warning:active:not(.button--disabled) {
    border-color: var(--sl-color-warning-700);
    background-color: var(--sl-color-warning-700);
    color: var(--sl-color-neutral-0);
  }

  /* Danger */
  .button--outline.button--danger {
    border-color: var(--sl-color-danger-600);
    color: var(--sl-color-danger-600);
  }

  .button--outline.button--danger:hover:not(.button--disabled),
  .button--outline.button--danger.button--checked:not(.button--disabled) {
    background-color: var(--sl-color-danger-600);
    color: var(--sl-color-neutral-0);
  }

  .button--outline.button--danger:active:not(.button--disabled) {
    border-color: var(--sl-color-danger-700);
    background-color: var(--sl-color-danger-700);
    color: var(--sl-color-neutral-0);
  }

  @media (forced-colors: active) {
    .button.button--outline.button--checked:not(.button--disabled) {
      outline: solid 2px transparent;
    }
  }

  /*
   * Text buttons
   */

  .button--text {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-600);
  }

  .button--text:hover:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:focus-visible:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-500);
  }

  .button--text:active:not(.button--disabled) {
    background-color: transparent;
    border-color: transparent;
    color: var(--sl-color-primary-700);
  }

  /*
   * Size modifiers
   */

  .button--small {
    height: auto;
    min-height: var(--sl-input-height-small);
    font-size: var(--sl-button-font-size-small);
    line-height: calc(var(--sl-input-height-small) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-small);
  }

  .button--medium {
    height: auto;
    min-height: var(--sl-input-height-medium);
    font-size: var(--sl-button-font-size-medium);
    line-height: calc(var(--sl-input-height-medium) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-medium);
  }

  .button--large {
    height: auto;
    min-height: var(--sl-input-height-large);
    font-size: var(--sl-button-font-size-large);
    line-height: calc(var(--sl-input-height-large) - var(--sl-input-border-width) * 2);
    border-radius: var(--sl-input-border-radius-large);
  }

  /*
   * Pill modifier
   */

  .button--pill.button--small {
    border-radius: var(--sl-input-height-small);
  }

  .button--pill.button--medium {
    border-radius: var(--sl-input-height-medium);
  }

  .button--pill.button--large {
    border-radius: var(--sl-input-height-large);
  }

  /*
   * Circle modifier
   */

  .button--circle {
    padding-left: 0;
    padding-right: 0;
  }

  .button--circle.button--small {
    width: var(--sl-input-height-small);
    border-radius: 50%;
  }

  .button--circle.button--medium {
    width: var(--sl-input-height-medium);
    border-radius: 50%;
  }

  .button--circle.button--large {
    width: var(--sl-input-height-large);
    border-radius: 50%;
  }

  .button--circle .button__prefix,
  .button--circle .button__suffix,
  .button--circle .button__caret {
    display: none;
  }

  /*
   * Caret modifier
   */

  .button--caret .button__suffix {
    display: none;
  }

  .button--caret .button__caret {
    height: auto;
  }

  /*
   * Loading modifier
   */

  .button--loading {
    position: relative;
    cursor: wait;
  }

  .button--loading .button__prefix,
  .button--loading .button__label,
  .button--loading .button__suffix,
  .button--loading .button__caret {
    visibility: hidden;
  }

  .button--loading sl-spinner {
    --indicator-color: currentColor;
    position: absolute;
    font-size: 1em;
    height: 1em;
    width: 1em;
    top: calc(50% - 0.5em);
    left: calc(50% - 0.5em);
  }

  /*
   * Badges
   */

  .button ::slotted(sl-badge) {
    position: absolute;
    top: 0;
    right: 0;
    translate: 50% -50%;
    pointer-events: none;
  }

  .button--rtl ::slotted(sl-badge) {
    right: auto;
    left: 0;
    translate: -50% -50%;
  }

  /*
   * Button spacing
   */

  .button--has-label.button--small .button__label {
    padding: 0 var(--sl-spacing-small);
  }

  .button--has-label.button--medium .button__label {
    padding: 0 var(--sl-spacing-medium);
  }

  .button--has-label.button--large .button__label {
    padding: 0 var(--sl-spacing-large);
  }

  .button--has-prefix.button--small {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--small .button__label {
    padding-inline-start: var(--sl-spacing-x-small);
  }

  .button--has-prefix.button--medium {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--medium .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-prefix.button--large .button__label {
    padding-inline-start: var(--sl-spacing-small);
  }

  .button--has-suffix.button--small,
  .button--caret.button--small {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--small .button__label,
  .button--caret.button--small .button__label {
    padding-inline-end: var(--sl-spacing-x-small);
  }

  .button--has-suffix.button--medium,
  .button--caret.button--medium {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--medium .button__label,
  .button--caret.button--medium .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large,
  .button--caret.button--large {
    padding-inline-end: var(--sl-spacing-small);
  }

  .button--has-suffix.button--large .button__label,
  .button--caret.button--large .button__label {
    padding-inline-end: var(--sl-spacing-small);
  }

  /*
   * Button groups support a variety of button types (e.g. buttons with tooltips, buttons as dropdown triggers, etc.).
   * This means buttons aren't always direct descendants of the button group, thus we can't target them with the
   * ::slotted selector. To work around this, the button group component does some magic to add these special classes to
   * buttons and we style them here instead.
   */

  :host([data-sl-button-group__button--first]:not([data-sl-button-group__button--last])) .button {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }

  :host([data-sl-button-group__button--inner]) .button {
    border-radius: 0;
  }

  :host([data-sl-button-group__button--last]:not([data-sl-button-group__button--first])) .button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }

  /* All except the first */
  :host([data-sl-button-group__button]:not([data-sl-button-group__button--first])) {
    margin-inline-start: calc(-1 * var(--sl-input-border-width));
  }

  /* Add a visual separator between solid buttons */
  :host(
      [data-sl-button-group__button]:not(
          [data-sl-button-group__button--first],
          [data-sl-button-group__button--radio],
          [variant='default']
        ):not(:hover)
    )
    .button:after {
    content: '';
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    bottom: 0;
    border-left: solid 1px rgb(128 128 128 / 33%);
    mix-blend-mode: multiply;
  }

  /* Bump hovered, focused, and checked buttons up so their focus ring isn't clipped */
  :host([data-sl-button-group__button--hover]) {
    z-index: 1;
  }

  /* Focus and checked are always on top */
  :host([data-sl-button-group__button--focus]),
  :host([data-sl-button-group__button][checked]) {
    z-index: 2;
  }
`, p = class extends z {
  constructor() {
    super(...arguments), this.formControlController = new j(this, {
      assumeInteractionOn: ["click"]
    }), this.hasSlotController = new rt(this, "[default]", "prefix", "suffix"), this.localize = new G(this), this.hasFocus = !1, this.invalid = !1, this.title = "", this.variant = "default", this.size = "medium", this.caret = !1, this.disabled = !1, this.loading = !1, this.outline = !1, this.pill = !1, this.circle = !1, this.type = "button", this.name = "", this.value = "", this.href = "", this.rel = "noreferrer noopener";
  }
  /** Gets the validity state object */
  get validity() {
    return this.isButton() ? this.button.validity : ct;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.isButton() ? this.button.validationMessage : "";
  }
  firstUpdated() {
    this.isButton() && this.formControlController.updateValidity();
  }
  handleBlur() {
    this.hasFocus = !1, this.emit("sl-blur");
  }
  handleFocus() {
    this.hasFocus = !0, this.emit("sl-focus");
  }
  handleClick() {
    this.type === "submit" && this.formControlController.submit(this), this.type === "reset" && this.formControlController.reset(this);
  }
  handleInvalid(t) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(t);
  }
  isButton() {
    return !this.href;
  }
  isLink() {
    return !!this.href;
  }
  handleDisabledChange() {
    this.isButton() && this.formControlController.setValidity(this.disabled);
  }
  /** Simulates a click on the button. */
  click() {
    this.button.click();
  }
  /** Sets focus on the button. */
  focus(t) {
    this.button.focus(t);
  }
  /** Removes focus from the button. */
  blur() {
    this.button.blur();
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.isButton() ? this.button.checkValidity() : !0;
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return this.isButton() ? this.button.reportValidity() : !0;
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(t) {
    this.isButton() && (this.button.setCustomValidity(t), this.formControlController.updateValidity());
  }
  render() {
    const t = this.isLink(), e = t ? W`a` : W`button`;
    return L`
      <${e}
        part="base"
        class=${V({
      button: !0,
      "button--default": this.variant === "default",
      "button--primary": this.variant === "primary",
      "button--success": this.variant === "success",
      "button--neutral": this.variant === "neutral",
      "button--warning": this.variant === "warning",
      "button--danger": this.variant === "danger",
      "button--text": this.variant === "text",
      "button--small": this.size === "small",
      "button--medium": this.size === "medium",
      "button--large": this.size === "large",
      "button--caret": this.caret,
      "button--circle": this.circle,
      "button--disabled": this.disabled,
      "button--focused": this.hasFocus,
      "button--loading": this.loading,
      "button--standard": !this.outline,
      "button--outline": this.outline,
      "button--pill": this.pill,
      "button--rtl": this.localize.dir() === "rtl",
      "button--has-label": this.hasSlotController.test("[default]"),
      "button--has-prefix": this.hasSlotController.test("prefix"),
      "button--has-suffix": this.hasSlotController.test("suffix")
    })}
        ?disabled=${b(t ? void 0 : this.disabled)}
        type=${b(t ? void 0 : this.type)}
        title=${this.title}
        name=${b(t ? void 0 : this.name)}
        value=${b(t ? void 0 : this.value)}
        href=${b(t && !this.disabled ? this.href : void 0)}
        target=${b(t ? this.target : void 0)}
        download=${b(t ? this.download : void 0)}
        rel=${b(t ? this.rel : void 0)}
        role=${b(t ? void 0 : "button")}
        aria-disabled=${this.disabled ? "true" : "false"}
        tabindex=${this.disabled ? "-1" : "0"}
        @blur=${this.handleBlur}
        @focus=${this.handleFocus}
        @invalid=${this.isButton() ? this.handleInvalid : null}
        @click=${this.handleClick}
      >
        <slot name="prefix" part="prefix" class="button__prefix"></slot>
        <slot part="label" class="button__label"></slot>
        <slot name="suffix" part="suffix" class="button__suffix"></slot>
        ${this.caret ? L` <sl-icon part="caret" class="button__caret" library="system" name="caret"></sl-icon> ` : ""}
        ${this.loading ? L`<sl-spinner part="spinner"></sl-spinner>` : ""}
      </${e}>
    `;
  }
};
p.styles = [H, yt];
p.dependencies = {
  "sl-icon": K,
  "sl-spinner": bt
};
s([
  C(".button")
], p.prototype, "button", 2);
s([
  k()
], p.prototype, "hasFocus", 2);
s([
  k()
], p.prototype, "invalid", 2);
s([
  l()
], p.prototype, "title", 2);
s([
  l({ reflect: !0 })
], p.prototype, "variant", 2);
s([
  l({ reflect: !0 })
], p.prototype, "size", 2);
s([
  l({ type: Boolean, reflect: !0 })
], p.prototype, "caret", 2);
s([
  l({ type: Boolean, reflect: !0 })
], p.prototype, "disabled", 2);
s([
  l({ type: Boolean, reflect: !0 })
], p.prototype, "loading", 2);
s([
  l({ type: Boolean, reflect: !0 })
], p.prototype, "outline", 2);
s([
  l({ type: Boolean, reflect: !0 })
], p.prototype, "pill", 2);
s([
  l({ type: Boolean, reflect: !0 })
], p.prototype, "circle", 2);
s([
  l()
], p.prototype, "type", 2);
s([
  l()
], p.prototype, "name", 2);
s([
  l()
], p.prototype, "value", 2);
s([
  l()
], p.prototype, "href", 2);
s([
  l()
], p.prototype, "target", 2);
s([
  l()
], p.prototype, "rel", 2);
s([
  l()
], p.prototype, "download", 2);
s([
  l()
], p.prototype, "form", 2);
s([
  l({ attribute: "formaction" })
], p.prototype, "formAction", 2);
s([
  l({ attribute: "formenctype" })
], p.prototype, "formEnctype", 2);
s([
  l({ attribute: "formmethod" })
], p.prototype, "formMethod", 2);
s([
  l({ attribute: "formnovalidate", type: Boolean })
], p.prototype, "formNoValidate", 2);
s([
  l({ attribute: "formtarget" })
], p.prototype, "formTarget", 2);
s([
  M("disabled", { waitUntilFirstUpdate: !0 })
], p.prototype, "handleDisabledChange", 1);
var _t = F`
  :host {
    display: inline-block;
  }

  .button-group {
    display: flex;
    flex-wrap: nowrap;
  }
`, B = class extends z {
  constructor() {
    super(...arguments), this.disableRole = !1, this.label = "";
  }
  handleFocus(t) {
    const e = A(t.target);
    e == null || e.toggleAttribute("data-sl-button-group__button--focus", !0);
  }
  handleBlur(t) {
    const e = A(t.target);
    e == null || e.toggleAttribute("data-sl-button-group__button--focus", !1);
  }
  handleMouseOver(t) {
    const e = A(t.target);
    e == null || e.toggleAttribute("data-sl-button-group__button--hover", !0);
  }
  handleMouseOut(t) {
    const e = A(t.target);
    e == null || e.toggleAttribute("data-sl-button-group__button--hover", !1);
  }
  handleSlotChange() {
    const t = [...this.defaultSlot.assignedElements({ flatten: !0 })];
    t.forEach((e) => {
      const r = t.indexOf(e), o = A(e);
      o && (o.toggleAttribute("data-sl-button-group__button", !0), o.toggleAttribute("data-sl-button-group__button--first", r === 0), o.toggleAttribute("data-sl-button-group__button--inner", r > 0 && r < t.length - 1), o.toggleAttribute("data-sl-button-group__button--last", r === t.length - 1), o.toggleAttribute(
        "data-sl-button-group__button--radio",
        o.tagName.toLowerCase() === "sl-radio-button"
      ));
    });
  }
  render() {
    return m`
      <div
        part="base"
        class="button-group"
        role="${this.disableRole ? "presentation" : "group"}"
        aria-label=${this.label}
        @focusout=${this.handleBlur}
        @focusin=${this.handleFocus}
        @mouseover=${this.handleMouseOver}
        @mouseout=${this.handleMouseOut}
      >
        <slot @slotchange=${this.handleSlotChange}></slot>
      </div>
    `;
  }
};
B.styles = [H, _t];
s([
  C("slot")
], B.prototype, "defaultSlot", 2);
s([
  k()
], B.prototype, "disableRole", 2);
s([
  l()
], B.prototype, "label", 2);
function A(t) {
  var e;
  const r = "sl-button, sl-radio-button";
  return (e = t.closest(r)) != null ? e : t.querySelector(r);
}
function f(t, e) {
  wt(t) && (t = "100%");
  const r = kt(t);
  return t = e === 360 ? t : Math.min(e, Math.max(0, parseFloat(t))), r && (t = parseInt(String(t * e), 10) / 100), Math.abs(t - e) < 1e-6 ? 1 : (e === 360 ? t = (t < 0 ? t % e + e : t % e) / parseFloat(String(e)) : t = t % e / parseFloat(String(e)), t);
}
function D(t) {
  return Math.min(1, Math.max(0, t));
}
function wt(t) {
  return typeof t == "string" && t.indexOf(".") !== -1 && parseFloat(t) === 1;
}
function kt(t) {
  return typeof t == "string" && t.indexOf("%") !== -1;
}
function it(t) {
  return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
}
function E(t) {
  return Number(t) <= 1 ? `${Number(t) * 100}%` : t;
}
function S(t) {
  return t.length === 1 ? "0" + t : String(t);
}
function xt(t, e, r) {
  return {
    r: f(t, 255) * 255,
    g: f(e, 255) * 255,
    b: f(r, 255) * 255
  };
}
function X(t, e, r) {
  t = f(t, 255), e = f(e, 255), r = f(r, 255);
  const o = Math.max(t, e, r), i = Math.min(t, e, r);
  let a = 0, n = 0;
  const h = (o + i) / 2;
  if (o === i)
    n = 0, a = 0;
  else {
    const c = o - i;
    switch (n = h > 0.5 ? c / (2 - o - i) : c / (o + i), o) {
      case t:
        a = (e - r) / c + (e < r ? 6 : 0);
        break;
      case e:
        a = (r - t) / c + 2;
        break;
      case r:
        a = (t - e) / c + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: n, l: h };
}
function N(t, e, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + (e - t) * (6 * r) : r < 1 / 2 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
}
function $t(t, e, r) {
  let o, i, a;
  if (t = f(t, 360), e = f(e, 100), r = f(r, 100), e === 0)
    i = r, a = r, o = r;
  else {
    const n = r < 0.5 ? r * (1 + e) : r + e - r * e, h = 2 * r - n;
    o = N(h, n, t + 1 / 3), i = N(h, n, t), a = N(h, n, t - 1 / 3);
  }
  return { r: o * 255, g: i * 255, b: a * 255 };
}
function Y(t, e, r) {
  t = f(t, 255), e = f(e, 255), r = f(r, 255);
  const o = Math.max(t, e, r), i = Math.min(t, e, r);
  let a = 0;
  const n = o, h = o - i, c = o === 0 ? 0 : h / o;
  if (o === i)
    a = 0;
  else {
    switch (o) {
      case t:
        a = (e - r) / h + (e < r ? 6 : 0);
        break;
      case e:
        a = (r - t) / h + 2;
        break;
      case r:
        a = (t - e) / h + 4;
        break;
    }
    a /= 6;
  }
  return { h: a, s: c, v: n };
}
function Ct(t, e, r) {
  t = f(t, 360) * 6, e = f(e, 100), r = f(r, 100);
  const o = Math.floor(t), i = t - o, a = r * (1 - e), n = r * (1 - i * e), h = r * (1 - (1 - i) * e), c = o % 6, R = [r, n, a, a, h, r][c], P = [h, r, r, n, a, a][c], at = [a, a, h, r, r, n][c];
  return { r: R * 255, g: P * 255, b: at * 255 };
}
function Z(t, e, r, o) {
  const i = [
    S(Math.round(t).toString(16)),
    S(Math.round(e).toString(16)),
    S(Math.round(r).toString(16))
  ];
  return o && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function St(t, e, r, o, i) {
  const a = [
    S(Math.round(t).toString(16)),
    S(Math.round(e).toString(16)),
    S(Math.round(r).toString(16)),
    S(Vt(o))
  ];
  return i && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) && a[3].startsWith(a[3].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0) : a.join("");
}
function Mt(t, e, r, o) {
  const i = t / 100, a = e / 100, n = r / 100, h = o / 100, c = 255 * (1 - i) * (1 - h), R = 255 * (1 - a) * (1 - h), P = 255 * (1 - n) * (1 - h);
  return { r: c, g: R, b: P };
}
function J(t, e, r) {
  let o = 1 - t / 255, i = 1 - e / 255, a = 1 - r / 255, n = Math.min(o, i, a);
  return n === 1 ? (o = 0, i = 0, a = 0) : (o = (o - n) / (1 - n) * 100, i = (i - n) / (1 - n) * 100, a = (a - n) / (1 - n) * 100), n *= 100, {
    c: Math.round(o),
    m: Math.round(i),
    y: Math.round(a),
    k: Math.round(n)
  };
}
function Vt(t) {
  return Math.round(parseFloat(t) * 255).toString(16);
}
function Q(t) {
  return y(t) / 255;
}
function y(t) {
  return parseInt(t, 16);
}
function At(t) {
  return {
    r: t >> 16,
    g: (t & 65280) >> 8,
    b: t & 255
  };
}
const q = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Ft(t) {
  let e = { r: 0, g: 0, b: 0 }, r = 1, o = null, i = null, a = null, n = !1, h = !1;
  return typeof t == "string" && (t = Bt(t)), typeof t == "object" && (v(t.r) && v(t.g) && v(t.b) ? (e = xt(t.r, t.g, t.b), n = !0, h = String(t.r).substr(-1) === "%" ? "prgb" : "rgb") : v(t.h) && v(t.s) && v(t.v) ? (o = E(t.s), i = E(t.v), e = Ct(t.h, o, i), n = !0, h = "hsv") : v(t.h) && v(t.s) && v(t.l) ? (o = E(t.s), a = E(t.l), e = $t(t.h, o, a), n = !0, h = "hsl") : v(t.c) && v(t.m) && v(t.y) && v(t.k) && (e = Mt(t.c, t.m, t.y, t.k), n = !0, h = "cmyk"), Object.prototype.hasOwnProperty.call(t, "a") && (r = t.a)), r = it(r), {
    ok: n,
    format: t.format || h,
    r: Math.min(255, Math.max(e.r, 0)),
    g: Math.min(255, Math.max(e.g, 0)),
    b: Math.min(255, Math.max(e.b, 0)),
    a: r
  };
}
const Ht = "[-\\+]?\\d+%?", zt = "[-\\+]?\\d*\\.\\d+%?", $ = "(?:" + zt + ")|(?:" + Ht + ")", O = "[\\s|\\(]+(" + $ + ")[,|\\s]+(" + $ + ")[,|\\s]+(" + $ + ")\\s*\\)?", I = (
  // eslint-disable-next-line prettier/prettier
  "[\\s|\\(]+(" + $ + ")[,|\\s]+(" + $ + ")[,|\\s]+(" + $ + ")[,|\\s]+(" + $ + ")\\s*\\)?"
), w = {
  CSS_UNIT: new RegExp($),
  rgb: new RegExp("rgb" + O),
  rgba: new RegExp("rgba" + I),
  hsl: new RegExp("hsl" + O),
  hsla: new RegExp("hsla" + I),
  hsv: new RegExp("hsv" + O),
  hsva: new RegExp("hsva" + I),
  cmyk: new RegExp("cmyk" + I),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Bt(t) {
  if (t = t.trim().toLowerCase(), t.length === 0)
    return !1;
  let e = !1;
  if (q[t])
    t = q[t], e = !0;
  else if (t === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  let r = w.rgb.exec(t);
  return r ? { r: r[1], g: r[2], b: r[3] } : (r = w.rgba.exec(t), r ? { r: r[1], g: r[2], b: r[3], a: r[4] } : (r = w.hsl.exec(t), r ? { h: r[1], s: r[2], l: r[3] } : (r = w.hsla.exec(t), r ? { h: r[1], s: r[2], l: r[3], a: r[4] } : (r = w.hsv.exec(t), r ? { h: r[1], s: r[2], v: r[3] } : (r = w.hsva.exec(t), r ? { h: r[1], s: r[2], v: r[3], a: r[4] } : (r = w.cmyk.exec(t), r ? {
    c: r[1],
    m: r[2],
    y: r[3],
    k: r[4]
  } : (r = w.hex8.exec(t), r ? {
    r: y(r[1]),
    g: y(r[2]),
    b: y(r[3]),
    a: Q(r[4]),
    format: e ? "name" : "hex8"
  } : (r = w.hex6.exec(t), r ? {
    r: y(r[1]),
    g: y(r[2]),
    b: y(r[3]),
    format: e ? "name" : "hex"
  } : (r = w.hex4.exec(t), r ? {
    r: y(r[1] + r[1]),
    g: y(r[2] + r[2]),
    b: y(r[3] + r[3]),
    a: Q(r[4] + r[4]),
    format: e ? "name" : "hex8"
  } : (r = w.hex3.exec(t), r ? {
    r: y(r[1] + r[1]),
    g: y(r[2] + r[2]),
    b: y(r[3] + r[3]),
    format: e ? "name" : "hex"
  } : !1))))))))));
}
function v(t) {
  return typeof t == "number" ? !Number.isNaN(t) : w.CSS_UNIT.test(t);
}
class g {
  constructor(e = "", r = {}) {
    if (e instanceof g)
      return e;
    typeof e == "number" && (e = At(e)), this.originalInput = e;
    const o = Ft(e);
    this.originalInput = e, this.r = o.r, this.g = o.g, this.b = o.b, this.a = o.a, this.roundA = Math.round(100 * this.a) / 100, this.format = r.format ?? o.format, this.gradientType = r.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = o.ok;
  }
  isDark() {
    return this.getBrightness() < 128;
  }
  isLight() {
    return !this.isDark();
  }
  /**
   * Returns the perceived brightness of the color, from 0-255.
   */
  getBrightness() {
    const e = this.toRgb();
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3;
  }
  /**
   * Returns the perceived luminance of a color, from 0-1.
   */
  getLuminance() {
    const e = this.toRgb();
    let r, o, i;
    const a = e.r / 255, n = e.g / 255, h = e.b / 255;
    return a <= 0.03928 ? r = a / 12.92 : r = Math.pow((a + 0.055) / 1.055, 2.4), n <= 0.03928 ? o = n / 12.92 : o = Math.pow((n + 0.055) / 1.055, 2.4), h <= 0.03928 ? i = h / 12.92 : i = Math.pow((h + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * o + 0.0722 * i;
  }
  /**
   * Returns the alpha value of a color, from 0-1.
   */
  getAlpha() {
    return this.a;
  }
  /**
   * Sets the alpha value on the current color.
   *
   * @param alpha - The new alpha value. The accepted range is 0-1.
   */
  setAlpha(e) {
    return this.a = it(e), this.roundA = Math.round(100 * this.a) / 100, this;
  }
  /**
   * Returns whether the color is monochrome.
   */
  isMonochrome() {
    const { s: e } = this.toHsl();
    return e === 0;
  }
  /**
   * Returns the object as a HSVA object.
   */
  toHsv() {
    const e = Y(this.r, this.g, this.b);
    return { h: e.h * 360, s: e.s, v: e.v, a: this.a };
  }
  /**
   * Returns the hsva values interpolated into a string with the following format:
   * "hsva(xxx, xxx, xxx, xx)".
   */
  toHsvString() {
    const e = Y(this.r, this.g, this.b), r = Math.round(e.h * 360), o = Math.round(e.s * 100), i = Math.round(e.v * 100);
    return this.a === 1 ? `hsv(${r}, ${o}%, ${i}%)` : `hsva(${r}, ${o}%, ${i}%, ${this.roundA})`;
  }
  /**
   * Returns the object as a HSLA object.
   */
  toHsl() {
    const e = X(this.r, this.g, this.b);
    return { h: e.h * 360, s: e.s, l: e.l, a: this.a };
  }
  /**
   * Returns the hsla values interpolated into a string with the following format:
   * "hsla(xxx, xxx, xxx, xx)".
   */
  toHslString() {
    const e = X(this.r, this.g, this.b), r = Math.round(e.h * 360), o = Math.round(e.s * 100), i = Math.round(e.l * 100);
    return this.a === 1 ? `hsl(${r}, ${o}%, ${i}%)` : `hsla(${r}, ${o}%, ${i}%, ${this.roundA})`;
  }
  /**
   * Returns the hex value of the color.
   * @param allow3Char will shorten hex value to 3 char if possible
   */
  toHex(e = !1) {
    return Z(this.r, this.g, this.b, e);
  }
  /**
   * Returns the hex value of the color -with a # prefixed.
   * @param allow3Char will shorten hex value to 3 char if possible
   */
  toHexString(e = !1) {
    return "#" + this.toHex(e);
  }
  /**
   * Returns the hex 8 value of the color.
   * @param allow4Char will shorten hex value to 4 char if possible
   */
  toHex8(e = !1) {
    return St(this.r, this.g, this.b, this.a, e);
  }
  /**
   * Returns the hex 8 value of the color -with a # prefixed.
   * @param allow4Char will shorten hex value to 4 char if possible
   */
  toHex8String(e = !1) {
    return "#" + this.toHex8(e);
  }
  /**
   * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
   * @param allowShortChar will shorten hex value to 3 or 4 char if possible
   */
  toHexShortString(e = !1) {
    return this.a === 1 ? this.toHexString(e) : this.toHex8String(e);
  }
  /**
   * Returns the object as a RGBA object.
   */
  toRgb() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  }
  /**
   * Returns the RGBA values interpolated into a string with the following format:
   * "RGBA(xxx, xxx, xxx, xx)".
   */
  toRgbString() {
    const e = Math.round(this.r), r = Math.round(this.g), o = Math.round(this.b);
    return this.a === 1 ? `rgb(${e}, ${r}, ${o})` : `rgba(${e}, ${r}, ${o}, ${this.roundA})`;
  }
  /**
   * Returns the object as a RGBA object.
   */
  toPercentageRgb() {
    const e = (r) => `${Math.round(f(r, 255) * 100)}%`;
    return {
      r: e(this.r),
      g: e(this.g),
      b: e(this.b),
      a: this.a
    };
  }
  /**
   * Returns the RGBA relative values interpolated into a string
   */
  toPercentageRgbString() {
    const e = (r) => Math.round(f(r, 255) * 100);
    return this.a === 1 ? `rgb(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%)` : `rgba(${e(this.r)}%, ${e(this.g)}%, ${e(this.b)}%, ${this.roundA})`;
  }
  toCmyk() {
    return {
      ...J(this.r, this.g, this.b)
    };
  }
  toCmykString() {
    const { c: e, m: r, y: o, k: i } = J(this.r, this.g, this.b);
    return `cmyk(${e}, ${r}, ${o}, ${i})`;
  }
  /**
   * The 'real' name of the color -if there is one.
   */
  toName() {
    if (this.a === 0)
      return "transparent";
    if (this.a < 1)
      return !1;
    const e = "#" + Z(this.r, this.g, this.b, !1);
    for (const [r, o] of Object.entries(q))
      if (e === o)
        return r;
    return !1;
  }
  toString(e) {
    const r = !!e;
    e = e ?? this.format;
    let o = !1;
    const i = this.a < 1 && this.a >= 0;
    return !r && i && (e.startsWith("hex") || e === "name") ? e === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (e === "rgb" && (o = this.toRgbString()), e === "prgb" && (o = this.toPercentageRgbString()), (e === "hex" || e === "hex6") && (o = this.toHexString()), e === "hex3" && (o = this.toHexString(!0)), e === "hex4" && (o = this.toHex8String(!0)), e === "hex8" && (o = this.toHex8String()), e === "name" && (o = this.toName()), e === "hsl" && (o = this.toHslString()), e === "hsv" && (o = this.toHsvString()), e === "cmyk" && (o = this.toCmykString()), o || this.toHexString());
  }
  toNumber() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  }
  clone() {
    return new g(this.toString());
  }
  /**
   * Lighten the color a given amount. Providing 100 will always return white.
   * @param amount - valid between 1-100
   */
  lighten(e = 10) {
    const r = this.toHsl();
    return r.l += e / 100, r.l = D(r.l), new g(r);
  }
  /**
   * Brighten the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */
  brighten(e = 10) {
    const r = this.toRgb();
    return r.r = Math.max(0, Math.min(255, r.r - Math.round(255 * -(e / 100)))), r.g = Math.max(0, Math.min(255, r.g - Math.round(255 * -(e / 100)))), r.b = Math.max(0, Math.min(255, r.b - Math.round(255 * -(e / 100)))), new g(r);
  }
  /**
   * Darken the color a given amount, from 0 to 100.
   * Providing 100 will always return black.
   * @param amount - valid between 1-100
   */
  darken(e = 10) {
    const r = this.toHsl();
    return r.l -= e / 100, r.l = D(r.l), new g(r);
  }
  /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   * @param amount - valid between 1-100
   */
  tint(e = 10) {
    return this.mix("white", e);
  }
  /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   * @param amount - valid between 1-100
   */
  shade(e = 10) {
    return this.mix("black", e);
  }
  /**
   * Desaturate the color a given amount, from 0 to 100.
   * Providing 100 will is the same as calling greyscale
   * @param amount - valid between 1-100
   */
  desaturate(e = 10) {
    const r = this.toHsl();
    return r.s -= e / 100, r.s = D(r.s), new g(r);
  }
  /**
   * Saturate the color a given amount, from 0 to 100.
   * @param amount - valid between 1-100
   */
  saturate(e = 10) {
    const r = this.toHsl();
    return r.s += e / 100, r.s = D(r.s), new g(r);
  }
  /**
   * Completely desaturates a color into greyscale.
   * Same as calling `desaturate(100)`
   */
  greyscale() {
    return this.desaturate(100);
  }
  /**
   * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
   * Values outside of this range will be wrapped into this range.
   */
  spin(e) {
    const r = this.toHsl(), o = (r.h + e) % 360;
    return r.h = o < 0 ? 360 + o : o, new g(r);
  }
  /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */
  mix(e, r = 50) {
    const o = this.toRgb(), i = new g(e).toRgb(), a = r / 100, n = {
      r: (i.r - o.r) * a + o.r,
      g: (i.g - o.g) * a + o.g,
      b: (i.b - o.b) * a + o.b,
      a: (i.a - o.a) * a + o.a
    };
    return new g(n);
  }
  analogous(e = 6, r = 30) {
    const o = this.toHsl(), i = 360 / r, a = [this];
    for (o.h = (o.h - (i * e >> 1) + 720) % 360; --e; )
      o.h = (o.h + i) % 360, a.push(new g(o));
    return a;
  }
  /**
   * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
   */
  complement() {
    const e = this.toHsl();
    return e.h = (e.h + 180) % 360, new g(e);
  }
  monochromatic(e = 6) {
    const r = this.toHsv(), { h: o } = r, { s: i } = r;
    let { v: a } = r;
    const n = [], h = 1 / e;
    for (; e--; )
      n.push(new g({ h: o, s: i, v: a })), a = (a + h) % 1;
    return n;
  }
  splitcomplement() {
    const e = this.toHsl(), { h: r } = e;
    return [
      this,
      new g({ h: (r + 72) % 360, s: e.s, l: e.l }),
      new g({ h: (r + 216) % 360, s: e.s, l: e.l })
    ];
  }
  /**
   * Compute how the color would appear on a background
   */
  onBackground(e) {
    const r = this.toRgb(), o = new g(e).toRgb(), i = r.a + o.a * (1 - r.a);
    return new g({
      r: (r.r * r.a + o.r * o.a * (1 - r.a)) / i,
      g: (r.g * r.a + o.g * o.a * (1 - r.a)) / i,
      b: (r.b * r.a + o.b * o.a * (1 - r.a)) / i,
      a: i
    });
  }
  /**
   * Alias for `polyad(3)`
   */
  triad() {
    return this.polyad(3);
  }
  /**
   * Alias for `polyad(4)`
   */
  tetrad() {
    return this.polyad(4);
  }
  /**
   * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
   * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
   */
  polyad(e) {
    const r = this.toHsl(), { h: o } = r, i = [this], a = 360 / e;
    for (let n = 1; n < e; n++)
      i.push(new g({ h: (o + n * a) % 360, s: r.s, l: r.l }));
    return i;
  }
  /**
   * compare color vs current color
   */
  equals(e) {
    const r = new g(e);
    return this.format === "cmyk" || r.format === "cmyk" ? this.toCmykString() === r.toCmykString() : this.toRgbString() === r.toRgbString();
  }
}
var tt = "EyeDropper" in window, d = class extends z {
  constructor() {
    super(), this.formControlController = new j(this), this.isSafeValue = !1, this.localize = new G(this), this.hasFocus = !1, this.isDraggingGridHandle = !1, this.isEmpty = !1, this.inputValue = "", this.hue = 0, this.saturation = 100, this.brightness = 100, this.alpha = 100, this.value = "", this.defaultValue = "", this.label = "", this.format = "hex", this.inline = !1, this.size = "medium", this.noFormatToggle = !1, this.name = "", this.disabled = !1, this.hoist = !1, this.opacity = !1, this.uppercase = !1, this.swatches = "", this.form = "", this.required = !1, this.handleFocusIn = () => {
      this.hasFocus = !0, this.emit("sl-focus");
    }, this.handleFocusOut = () => {
      this.hasFocus = !1, this.emit("sl-blur");
    }, this.addEventListener("focusin", this.handleFocusIn), this.addEventListener("focusout", this.handleFocusOut);
  }
  /** Gets the validity state object */
  get validity() {
    return this.input.validity;
  }
  /** Gets the validation message */
  get validationMessage() {
    return this.input.validationMessage;
  }
  firstUpdated() {
    this.input.updateComplete.then(() => {
      this.formControlController.updateValidity();
    });
  }
  handleCopy() {
    this.input.select(), document.execCommand("copy"), this.previewButton.focus(), this.previewButton.classList.add("color-picker__preview-color--copied"), this.previewButton.addEventListener("animationend", () => {
      this.previewButton.classList.remove("color-picker__preview-color--copied");
    });
  }
  handleFormatToggle() {
    const t = ["hex", "rgb", "hsl", "hsv"], e = (t.indexOf(this.format) + 1) % t.length;
    this.format = t[e], this.setColor(this.value), this.emit("sl-change"), this.emit("sl-input");
  }
  handleAlphaDrag(t) {
    const e = this.shadowRoot.querySelector(".color-picker__slider.color-picker__alpha"), r = e.querySelector(".color-picker__slider-handle"), { width: o } = e.getBoundingClientRect();
    let i = this.value, a = this.value;
    r.focus(), t.preventDefault(), T(e, {
      onMove: (n) => {
        this.alpha = _(n / o * 100, 0, 100), this.syncValues(), this.value !== a && (a = this.value, this.emit("sl-input"));
      },
      onStop: () => {
        this.value !== i && (i = this.value, this.emit("sl-change"));
      },
      initialEvent: t
    });
  }
  handleHueDrag(t) {
    const e = this.shadowRoot.querySelector(".color-picker__slider.color-picker__hue"), r = e.querySelector(".color-picker__slider-handle"), { width: o } = e.getBoundingClientRect();
    let i = this.value, a = this.value;
    r.focus(), t.preventDefault(), T(e, {
      onMove: (n) => {
        this.hue = _(n / o * 360, 0, 360), this.syncValues(), this.value !== a && (a = this.value, this.emit("sl-input"));
      },
      onStop: () => {
        this.value !== i && (i = this.value, this.emit("sl-change"));
      },
      initialEvent: t
    });
  }
  handleGridDrag(t) {
    const e = this.shadowRoot.querySelector(".color-picker__grid"), r = e.querySelector(".color-picker__grid-handle"), { width: o, height: i } = e.getBoundingClientRect();
    let a = this.value, n = this.value;
    r.focus(), t.preventDefault(), this.isDraggingGridHandle = !0, T(e, {
      onMove: (h, c) => {
        this.saturation = _(h / o * 100, 0, 100), this.brightness = _(100 - c / i * 100, 0, 100), this.syncValues(), this.value !== n && (n = this.value, this.emit("sl-input"));
      },
      onStop: () => {
        this.isDraggingGridHandle = !1, this.value !== a && (a = this.value, this.emit("sl-change"));
      },
      initialEvent: t
    });
  }
  handleAlphaKeyDown(t) {
    const e = t.shiftKey ? 10 : 1, r = this.value;
    t.key === "ArrowLeft" && (t.preventDefault(), this.alpha = _(this.alpha - e, 0, 100), this.syncValues()), t.key === "ArrowRight" && (t.preventDefault(), this.alpha = _(this.alpha + e, 0, 100), this.syncValues()), t.key === "Home" && (t.preventDefault(), this.alpha = 0, this.syncValues()), t.key === "End" && (t.preventDefault(), this.alpha = 100, this.syncValues()), this.value !== r && (this.emit("sl-change"), this.emit("sl-input"));
  }
  handleHueKeyDown(t) {
    const e = t.shiftKey ? 10 : 1, r = this.value;
    t.key === "ArrowLeft" && (t.preventDefault(), this.hue = _(this.hue - e, 0, 360), this.syncValues()), t.key === "ArrowRight" && (t.preventDefault(), this.hue = _(this.hue + e, 0, 360), this.syncValues()), t.key === "Home" && (t.preventDefault(), this.hue = 0, this.syncValues()), t.key === "End" && (t.preventDefault(), this.hue = 360, this.syncValues()), this.value !== r && (this.emit("sl-change"), this.emit("sl-input"));
  }
  handleGridKeyDown(t) {
    const e = t.shiftKey ? 10 : 1, r = this.value;
    t.key === "ArrowLeft" && (t.preventDefault(), this.saturation = _(this.saturation - e, 0, 100), this.syncValues()), t.key === "ArrowRight" && (t.preventDefault(), this.saturation = _(this.saturation + e, 0, 100), this.syncValues()), t.key === "ArrowUp" && (t.preventDefault(), this.brightness = _(this.brightness + e, 0, 100), this.syncValues()), t.key === "ArrowDown" && (t.preventDefault(), this.brightness = _(this.brightness - e, 0, 100), this.syncValues()), this.value !== r && (this.emit("sl-change"), this.emit("sl-input"));
  }
  handleInputChange(t) {
    const e = t.target, r = this.value;
    t.stopPropagation(), this.input.value ? (this.setColor(e.value), e.value = this.value) : this.value = "", this.value !== r && (this.emit("sl-change"), this.emit("sl-input"));
  }
  handleInputInput(t) {
    this.formControlController.updateValidity(), t.stopPropagation();
  }
  handleInputKeyDown(t) {
    if (t.key === "Enter") {
      const e = this.value;
      this.input.value ? (this.setColor(this.input.value), this.input.value = this.value, this.value !== e && (this.emit("sl-change"), this.emit("sl-input")), setTimeout(() => this.input.select())) : this.hue = 0;
    }
  }
  handleInputInvalid(t) {
    this.formControlController.setValidity(!1), this.formControlController.emitInvalidEvent(t);
  }
  handleTouchMove(t) {
    t.preventDefault();
  }
  parseColor(t) {
    const e = new g(t);
    if (!e.isValid)
      return null;
    const r = e.toHsl(), o = {
      h: r.h,
      s: r.s * 100,
      l: r.l * 100,
      a: r.a
    }, i = e.toRgb(), a = e.toHexString(), n = e.toHex8String(), h = e.toHsv(), c = {
      h: h.h,
      s: h.s * 100,
      v: h.v * 100,
      a: h.a
    };
    return {
      hsl: {
        h: o.h,
        s: o.s,
        l: o.l,
        string: this.setLetterCase(`hsl(${Math.round(o.h)}, ${Math.round(o.s)}%, ${Math.round(o.l)}%)`)
      },
      hsla: {
        h: o.h,
        s: o.s,
        l: o.l,
        a: o.a,
        string: this.setLetterCase(
          `hsla(${Math.round(o.h)}, ${Math.round(o.s)}%, ${Math.round(o.l)}%, ${o.a.toFixed(2).toString()})`
        )
      },
      hsv: {
        h: c.h,
        s: c.s,
        v: c.v,
        string: this.setLetterCase(`hsv(${Math.round(c.h)}, ${Math.round(c.s)}%, ${Math.round(c.v)}%)`)
      },
      hsva: {
        h: c.h,
        s: c.s,
        v: c.v,
        a: c.a,
        string: this.setLetterCase(
          `hsva(${Math.round(c.h)}, ${Math.round(c.s)}%, ${Math.round(c.v)}%, ${c.a.toFixed(2).toString()})`
        )
      },
      rgb: {
        r: i.r,
        g: i.g,
        b: i.b,
        string: this.setLetterCase(`rgb(${Math.round(i.r)}, ${Math.round(i.g)}, ${Math.round(i.b)})`)
      },
      rgba: {
        r: i.r,
        g: i.g,
        b: i.b,
        a: i.a,
        string: this.setLetterCase(
          `rgba(${Math.round(i.r)}, ${Math.round(i.g)}, ${Math.round(i.b)}, ${i.a.toFixed(2).toString()})`
        )
      },
      hex: this.setLetterCase(a),
      hexa: this.setLetterCase(n)
    };
  }
  setColor(t) {
    const e = this.parseColor(t);
    return e === null ? !1 : (this.hue = e.hsva.h, this.saturation = e.hsva.s, this.brightness = e.hsva.v, this.alpha = this.opacity ? e.hsva.a * 100 : 100, this.syncValues(), !0);
  }
  setLetterCase(t) {
    return typeof t != "string" ? "" : this.uppercase ? t.toUpperCase() : t.toLowerCase();
  }
  async syncValues() {
    const t = this.parseColor(
      `hsva(${this.hue}, ${this.saturation}%, ${this.brightness}%, ${this.alpha / 100})`
    );
    t !== null && (this.format === "hsl" ? this.inputValue = this.opacity ? t.hsla.string : t.hsl.string : this.format === "rgb" ? this.inputValue = this.opacity ? t.rgba.string : t.rgb.string : this.format === "hsv" ? this.inputValue = this.opacity ? t.hsva.string : t.hsv.string : this.inputValue = this.opacity ? t.hexa : t.hex, this.isSafeValue = !0, this.value = this.inputValue, await this.updateComplete, this.isSafeValue = !1);
  }
  handleAfterHide() {
    this.previewButton.classList.remove("color-picker__preview-color--copied");
  }
  handleEyeDropper() {
    if (!tt)
      return;
    new EyeDropper().open().then((e) => {
      const r = this.value;
      this.setColor(e.sRGBHex), this.value !== r && (this.emit("sl-change"), this.emit("sl-input"));
    }).catch(() => {
    });
  }
  selectSwatch(t) {
    const e = this.value;
    this.disabled || (this.setColor(t), this.value !== e && (this.emit("sl-change"), this.emit("sl-input")));
  }
  /** Generates a hex string from HSV values. Hue must be 0-360. All other arguments must be 0-100. */
  getHexString(t, e, r, o = 100) {
    const i = new g(`hsva(${t}, ${e}%, ${r}%, ${o / 100})`);
    return i.isValid ? i.toHex8String() : "";
  }
  // Prevents nested components from leaking events
  stopNestedEventPropagation(t) {
    t.stopImmediatePropagation();
  }
  handleFormatChange() {
    this.syncValues();
  }
  handleOpacityChange() {
    this.alpha = 100;
  }
  handleValueChange(t, e) {
    if (this.isEmpty = !e, e || (this.hue = 0, this.saturation = 0, this.brightness = 100, this.alpha = 100), !this.isSafeValue) {
      const r = this.parseColor(e);
      r !== null ? (this.inputValue = this.value, this.hue = r.hsva.h, this.saturation = r.hsva.s, this.brightness = r.hsva.v, this.alpha = r.hsva.a * 100, this.syncValues()) : this.inputValue = t ?? "";
    }
  }
  /** Sets focus on the color picker. */
  focus(t) {
    this.inline ? this.base.focus(t) : this.trigger.focus(t);
  }
  /** Removes focus from the color picker. */
  blur() {
    var t;
    const e = this.inline ? this.base : this.trigger;
    this.hasFocus && (e.focus({ preventScroll: !0 }), e.blur()), (t = this.dropdown) != null && t.open && this.dropdown.hide();
  }
  /** Returns the current value as a string in the specified format. */
  getFormattedValue(t = "hex") {
    const e = this.parseColor(
      `hsva(${this.hue}, ${this.saturation}%, ${this.brightness}%, ${this.alpha / 100})`
    );
    if (e === null)
      return "";
    switch (t) {
      case "hex":
        return e.hex;
      case "hexa":
        return e.hexa;
      case "rgb":
        return e.rgb.string;
      case "rgba":
        return e.rgba.string;
      case "hsl":
        return e.hsl.string;
      case "hsla":
        return e.hsla.string;
      case "hsv":
        return e.hsv.string;
      case "hsva":
        return e.hsva.string;
      default:
        return "";
    }
  }
  /** Checks for validity but does not show a validation message. Returns `true` when valid and `false` when invalid. */
  checkValidity() {
    return this.input.checkValidity();
  }
  /** Gets the associated form, if one exists. */
  getForm() {
    return this.formControlController.getForm();
  }
  /** Checks for validity and shows the browser's validation message if the control is invalid. */
  reportValidity() {
    return !this.inline && !this.validity.valid ? (this.dropdown.show(), this.addEventListener("sl-after-show", () => this.input.reportValidity(), { once: !0 }), this.disabled || this.formControlController.emitInvalidEvent(), !1) : this.input.reportValidity();
  }
  /** Sets a custom validation message. Pass an empty string to restore validity. */
  setCustomValidity(t) {
    this.input.setCustomValidity(t), this.formControlController.updateValidity();
  }
  render() {
    const t = this.saturation, e = 100 - this.brightness, r = Array.isArray(this.swatches) ? this.swatches : this.swatches.split(";").filter((i) => i.trim() !== ""), o = m`
      <div
        part="base"
        class=${V({
      "color-picker": !0,
      "color-picker--inline": this.inline,
      "color-picker--disabled": this.disabled,
      "color-picker--focused": this.hasFocus
    })}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-labelledby="label"
        tabindex=${this.inline ? "0" : "-1"}
      >
        ${this.inline ? m`
              <sl-visually-hidden id="label">
                <slot name="label">${this.label}</slot>
              </sl-visually-hidden>
            ` : null}

        <div
          part="grid"
          class="color-picker__grid"
          style=${x({ backgroundColor: this.getHexString(this.hue, 100, 100) })}
          @pointerdown=${this.handleGridDrag}
          @touchmove=${this.handleTouchMove}
        >
          <span
            part="grid-handle"
            class=${V({
      "color-picker__grid-handle": !0,
      "color-picker__grid-handle--dragging": this.isDraggingGridHandle
    })}
            style=${x({
      top: `${e}%`,
      left: `${t}%`,
      backgroundColor: this.getHexString(this.hue, this.saturation, this.brightness, this.alpha)
    })}
            role="application"
            aria-label="HSV"
            tabindex=${b(this.disabled ? void 0 : "0")}
            @keydown=${this.handleGridKeyDown}
          ></span>
        </div>

        <div class="color-picker__controls">
          <div class="color-picker__sliders">
            <div
              part="slider hue-slider"
              class="color-picker__hue color-picker__slider"
              @pointerdown=${this.handleHueDrag}
              @touchmove=${this.handleTouchMove}
            >
              <span
                part="slider-handle hue-slider-handle"
                class="color-picker__slider-handle"
                style=${x({
      left: `${this.hue === 0 ? 0 : 100 / (360 / this.hue)}%`
    })}
                role="slider"
                aria-label="hue"
                aria-orientation="horizontal"
                aria-valuemin="0"
                aria-valuemax="360"
                aria-valuenow=${`${Math.round(this.hue)}`}
                tabindex=${b(this.disabled ? void 0 : "0")}
                @keydown=${this.handleHueKeyDown}
              ></span>
            </div>

            ${this.opacity ? m`
                  <div
                    part="slider opacity-slider"
                    class="color-picker__alpha color-picker__slider color-picker__transparent-bg"
                    @pointerdown="${this.handleAlphaDrag}"
                    @touchmove=${this.handleTouchMove}
                  >
                    <div
                      class="color-picker__alpha-gradient"
                      style=${x({
      backgroundImage: `linear-gradient(
                          to right,
                          ${this.getHexString(this.hue, this.saturation, this.brightness, 0)} 0%,
                          ${this.getHexString(this.hue, this.saturation, this.brightness, 100)} 100%
                        )`
    })}
                    ></div>
                    <span
                      part="slider-handle opacity-slider-handle"
                      class="color-picker__slider-handle"
                      style=${x({
      left: `${this.alpha}%`
    })}
                      role="slider"
                      aria-label="alpha"
                      aria-orientation="horizontal"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      aria-valuenow=${Math.round(this.alpha)}
                      tabindex=${b(this.disabled ? void 0 : "0")}
                      @keydown=${this.handleAlphaKeyDown}
                    ></span>
                  </div>
                ` : ""}
          </div>

          <button
            type="button"
            part="preview"
            class="color-picker__preview color-picker__transparent-bg"
            aria-label=${this.localize.term("copy")}
            style=${x({
      "--preview-color": this.getHexString(this.hue, this.saturation, this.brightness, this.alpha)
    })}
            @click=${this.handleCopy}
          ></button>
        </div>

        <div class="color-picker__user-input" aria-live="polite">
          <sl-input
            part="input"
            type="text"
            name=${this.name}
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            value=${this.isEmpty ? "" : this.inputValue}
            ?required=${this.required}
            ?disabled=${this.disabled}
            aria-label=${this.localize.term("currentValue")}
            @keydown=${this.handleInputKeyDown}
            @sl-change=${this.handleInputChange}
            @sl-input=${this.handleInputInput}
            @sl-invalid=${this.handleInputInvalid}
            @sl-blur=${this.stopNestedEventPropagation}
            @sl-focus=${this.stopNestedEventPropagation}
          ></sl-input>

          <sl-button-group>
            ${this.noFormatToggle ? "" : m`
                  <sl-button
                    part="format-button"
                    aria-label=${this.localize.term("toggleColorFormat")}
                    exportparts="
                      base:format-button__base,
                      prefix:format-button__prefix,
                      label:format-button__label,
                      suffix:format-button__suffix,
                      caret:format-button__caret
                    "
                    @click=${this.handleFormatToggle}
                    @sl-blur=${this.stopNestedEventPropagation}
                    @sl-focus=${this.stopNestedEventPropagation}
                  >
                    ${this.setLetterCase(this.format)}
                  </sl-button>
                `}
            ${tt ? m`
                  <sl-button
                    part="eye-dropper-button"
                    exportparts="
                      base:eye-dropper-button__base,
                      prefix:eye-dropper-button__prefix,
                      label:eye-dropper-button__label,
                      suffix:eye-dropper-button__suffix,
                      caret:eye-dropper-button__caret
                    "
                    @click=${this.handleEyeDropper}
                    @sl-blur=${this.stopNestedEventPropagation}
                    @sl-focus=${this.stopNestedEventPropagation}
                  >
                    <sl-icon
                      library="system"
                      name="eyedropper"
                      label=${this.localize.term("selectAColorFromTheScreen")}
                    ></sl-icon>
                  </sl-button>
                ` : ""}
          </sl-button-group>
        </div>

        ${r.length > 0 ? m`
              <div part="swatches" class="color-picker__swatches">
                ${r.map((i) => {
      const a = this.parseColor(i);
      return a ? m`
                    <div
                      part="swatch"
                      class="color-picker__swatch color-picker__transparent-bg"
                      tabindex=${b(this.disabled ? void 0 : "0")}
                      role="button"
                      aria-label=${i}
                      @click=${() => this.selectSwatch(i)}
                      @keydown=${(n) => !this.disabled && n.key === "Enter" && this.setColor(a.hexa)}
                    >
                      <div
                        class="color-picker__swatch-color"
                        style=${x({ backgroundColor: a.hexa })}
                      ></div>
                    </div>
                  ` : (console.error(`Unable to parse swatch color: "${i}"`, this), "");
    })}
              </div>
            ` : ""}
      </div>
    `;
    return this.inline ? o : m`
      <sl-dropdown
        class="color-dropdown"
        aria-disabled=${this.disabled ? "true" : "false"}
        .containing-element=${this}
        ?disabled=${this.disabled}
        ?hoist=${this.hoist}
        @sl-after-hide=${this.handleAfterHide}
      >
        <button
          part="trigger"
          slot="trigger"
          class=${V({
      "color-dropdown__trigger": !0,
      "color-dropdown__trigger--disabled": this.disabled,
      "color-dropdown__trigger--small": this.size === "small",
      "color-dropdown__trigger--medium": this.size === "medium",
      "color-dropdown__trigger--large": this.size === "large",
      "color-dropdown__trigger--empty": this.isEmpty,
      "color-dropdown__trigger--focused": this.hasFocus,
      "color-picker__transparent-bg": !0
    })}
          style=${x({
      color: this.getHexString(this.hue, this.saturation, this.brightness, this.alpha)
    })}
          type="button"
        >
          <sl-visually-hidden>
            <slot name="label">${this.label}</slot>
          </sl-visually-hidden>
        </button>
        ${o}
      </sl-dropdown>
    `;
  }
};
d.styles = [H, vt];
d.dependencies = {
  "sl-button-group": B,
  "sl-button": p,
  "sl-dropdown": pt,
  "sl-icon": K,
  "sl-input": u,
  "sl-visually-hidden": ot
};
s([
  C('[part~="base"]')
], d.prototype, "base", 2);
s([
  C('[part~="input"]')
], d.prototype, "input", 2);
s([
  C(".color-dropdown")
], d.prototype, "dropdown", 2);
s([
  C('[part~="preview"]')
], d.prototype, "previewButton", 2);
s([
  C('[part~="trigger"]')
], d.prototype, "trigger", 2);
s([
  k()
], d.prototype, "hasFocus", 2);
s([
  k()
], d.prototype, "isDraggingGridHandle", 2);
s([
  k()
], d.prototype, "isEmpty", 2);
s([
  k()
], d.prototype, "inputValue", 2);
s([
  k()
], d.prototype, "hue", 2);
s([
  k()
], d.prototype, "saturation", 2);
s([
  k()
], d.prototype, "brightness", 2);
s([
  k()
], d.prototype, "alpha", 2);
s([
  l()
], d.prototype, "value", 2);
s([
  et()
], d.prototype, "defaultValue", 2);
s([
  l()
], d.prototype, "label", 2);
s([
  l()
], d.prototype, "format", 2);
s([
  l({ type: Boolean, reflect: !0 })
], d.prototype, "inline", 2);
s([
  l({ reflect: !0 })
], d.prototype, "size", 2);
s([
  l({ attribute: "no-format-toggle", type: Boolean })
], d.prototype, "noFormatToggle", 2);
s([
  l()
], d.prototype, "name", 2);
s([
  l({ type: Boolean, reflect: !0 })
], d.prototype, "disabled", 2);
s([
  l({ type: Boolean })
], d.prototype, "hoist", 2);
s([
  l({ type: Boolean })
], d.prototype, "opacity", 2);
s([
  l({ type: Boolean })
], d.prototype, "uppercase", 2);
s([
  l()
], d.prototype, "swatches", 2);
s([
  l({ reflect: !0 })
], d.prototype, "form", 2);
s([
  l({ type: Boolean, reflect: !0 })
], d.prototype, "required", 2);
s([
  gt({ passive: !1 })
], d.prototype, "handleTouchMove", 1);
s([
  M("format", { waitUntilFirstUpdate: !0 })
], d.prototype, "handleFormatChange", 1);
s([
  M("opacity", { waitUntilFirstUpdate: !0 })
], d.prototype, "handleOpacityChange", 1);
s([
  M("value")
], d.prototype, "handleValueChange", 1);
var st = d;
d.define("sl-color-picker");
const Dt = ":host::part(trigger):before{--sl-input-border-color: var(--core-color-monochrome-200)}:host::part(trigger):focus-visible,:host::part(grid-handle):focus-visible,:host::part(slider-handle):focus-visible,:host::part(preview):focus-visible,:host::part(swatch):focus-visible,:host sl-button::part(base):focus-visible{outline:none!important;box-shadow:0 0 4px var(--core-color-blue-800)!important}:host sl-input{--sl-input-border-color-focus: var(--core-color-blue-800);--sl-focus-ring-width: 0px}:host::part(base){--sl-input-border-color: var(--core-color-monochrome-200)}:host::part(base):hover{--sl-input-background-color-hover: var(--core-color-blue-50);--sl-input-border-color-hover: var(--core-color-blue-800)}:host sl-button::part(base){--sl-input-border-color: var(--core-color-monochrome-200)}:host sl-button::part(base):hover{--sl-color-primary-50: var(--core-color-blue-50);--sl-color-primary-300: var(--core-color-blue-800);--sl-color-primary-700: var(--core-color-blue-800)}:host::part(swatches){--sl-color-neutral-200: var(--sl-panel-border-color)}";
var Et = Object.defineProperty, It = Object.getOwnPropertyDescriptor, Rt = (t, e, r, o) => {
  for (var i = o > 1 ? void 0 : o ? It(e, r) : e, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (i = (o ? n(e, r, i) : n(i)) || i);
  return o && i && Et(e, r, i), i;
};
let U = class extends st {
  constructor() {
    super(), new ut(this, [
      "sl-blur",
      "sl-change",
      "sl-focus",
      "sl-input",
      "sl-invalid"
    ]);
  }
};
U.styles = [
  st.styles,
  lt(Dt)
];
U = Rt([
  nt("pwc-color-picker")
], U);
export {
  U as PwcColorPicker
};
